<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div class="btnAdd">
        <el-button type="primary" icon="el-icon-plus" @click="showEdit"
          >上传版本</el-button
        >
      </div>
    </div>
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showSelect="false"
        :showIndex="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:client_type="{ row }">
          {{ { 1: "企业端", 2: "个人端" }[row.client_type] }}
        </template>
        <template v-slot:content="{ row }">
          <div v-html="remarkHTML(row.content)"></div>
        </template>
        <template v-slot:action="{ row }">
          <el-button
            plain
            icon="el-icon-edit"
            @click="showEdit(row)"
            size="mini"
            >编辑</el-button
          >
          <el-button
            plain
            icon="el-icon-download"
            @click="openPath(row)"
            size="mini"
            >下载</el-button
          >
          <el-button
            plain
            icon="el-icon-delete"
            @click="remove(row)"
            size="mini"
            >删除</el-button
          >
        </template>
      </VTable>
    </div>
    <!-- 编辑 -->
    <edit ref="edit" @refresh="getTable"></edit>
  </div>
</template>

<script>
import Edit from "./components/Edit.vue";
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "SetEdition",
  components: {
    Edit,
    VTable,
  },
  mixins: [mixinTable],
  data() {
    return {
      field: [
        { name: "client_type", label: "客户端口", hidden: false },
        { name: "version", label: "版本日期", hidden: false },
        { name: "desc", label: "版本号", hidden: false },
        { name: "content", label: "更新内容", hidden: false },
        { name: "create_time", label: "发布时间", hidden: false },
        { name: "action", label: "操作", width: "260", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
          name: "",
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.table.loading = true;
      this.$http
        .get("/admin/app/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    // 新增、编辑
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    remove(row) {
      this.$confirm("请确认删除操作?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post("admin/app/delete", { id: row.id }).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.getTable();
            }
          });
        })
        .catch(() => {});
    },
    openPath(row) {
      window.open(row.app_url, "_blank");
    },
    remarkHTML(remark) {
      if (remark) {
        return remark.replace(/\n/g, "<br>");
      }
      return "";
    },
  },
};
</script>

<style scoped>
:v-deep .el-textarea {
  margin: 10px 0;
}
:v-deep .el-textarea_inner {
  resize: none !important;
  white-space: pre-wrap !important;
  background: none !important;
  border: none !important;
}
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;
}

.filter__wrap {
  padding: 10px;
  margin-bottom: 20px;
}
.table__wrap {
  flex: 1;
  padding: 0;
  box-sizing: border-box;
}
</style>